<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import Header from "@/components/Header.vue";
import MainHeader from "@/components/MainHeader.vue";
import MainFooter from "@/components/MainFooter.vue";
import ScrollAnimation from "@/components/ScrollAnimation.vue";
import MobileMainHeader from "@/components/mobile/MMainHeader.vue";
import MobileMainFooter from "@/components/mobile/MMainFooter.vue";
import TopButton from "@/components/TopButton.vue";
import MobileTopButton from "@/components/mobile/MTopButton.vue";
import dotenv from "dotenv";

export default {
  name: "Footer",
  data() {
    return {
      footers: [
        // {
        //   text : '개인정보처리방침',
        //   src : '/privacy/privacyPolicy'
        // },

        {
          text : '보청기 실제 사용 후기',
          src : '/reviews/real-usage'
        },
        {
          text : '오시는 길',
          src : '/about/directions'
        }
        // '고정형 영상정보처리기기 운영·관리방침',
        // '이메일주소 무단수집거부',
      ],
      familySites: [
        {
          name: '다비치마켓',
          url: 'https://www.davichmarket.com/'
        },
        {
          name: '다비치 기업 홈페이지',
          url: 'https://davich.com/'
        }
      ],
      isFamilySiteOpen: false
    };
  },
  components: {
  },
  methods: {
    toggleFamilySite() {
      this.isFamilySiteOpen = !this.isFamilySiteOpen;
    },
    goToSite(url) {
      window.open(url, '_blank');
    }
  },
  created() {
  },
  mounted() {},
};


</script>

<template>
  <footer>
    <div class="footer__inner-1">
      <span>다비치 히어링 보청기</span>
      <div class="footer__inner-1-icon-wrapper">
        <a href="https://blog.naver.com/davichhearing_aid">
          <img src="@/assets/icons/icon-blog.svg" width="30" alt="히어링 블로그 바로가기 아이콘">
        </a>
        <a href="https://www.youtube.com/channel/UCSg8rRN7ysxvrNA6hO2j2ag">
          <img src="@/assets/icons/icon-youtube.svg" width="30" alt="히어링 유트브 바로가기 아이콘">
        </a>
      </div>
    </div>
    <div>
      <ul class="footer__inner-2">
        <li>
          <a href="https://davichmarket.com/terms/privacy?home=hearing" target="_blank" class="bold">
            개인정보처리방침
          </a>
        </li>
          <li v-for="ele in footers" :key="ele">
            <router-link :to="ele.src">
              {{ele.text}}
            </router-link>
          </li>
      </ul>
      <ul class="footer__inner-2">
        <li class="family-site-wrapper">
          <div
            class="family-site-header"
            @click="toggleFamilySite"
          >
            <span>Family Site</span>
            <span
              class="arrow-icon"
              :class="{ 'rotated': isFamilySiteOpen }"
            >
              <img src="@/assets/icons/icon-header-arrow.svg" alt="패밀리 사이트 펼쳐보기" width="22">
            </span>
          </div>
          <transition name="dropdown">
            <ul
              v-if="isFamilySiteOpen"
              class="family-site-dropdown"
            >
              <li
                v-for="site in familySites"
                :key="site.name"
                @click="goToSite(site.url)"
                class="family-site-item"
              >
                {{ site.name }}
              </li>
            </ul>
          </transition>
        </li>
      </ul>


      <div class="footer__inner-3">
        COPYRIGHT© DAVICH OPTICAL. ALL RIGHTS RESERVED.
      </div>

      <div class="footer__inner-4">
        대표이사 : 김인규, 김봉건 <br>
        주소 : 서울 종로구 수표로 91 다비치타워 8-11F <br>
        사업자 등록번호 : 159-85-01083 <br>
        의료기기 판매업 신고번호 : 제 2025-3000034-00008호 <br>
<!--        의료기기 광고 사전심의번호 : 2016GN1350095<br>-->
<!--        대표번호 : 1668-1407<br>-->
<!--        Fax : 02-752-6176<br>-->
      </div>
    </div>

  </footer>
</template>

<style scoped lang="scss">
.bold{
  font-weight: bold;
  //color: #1e3a8a;
}
footer{
  margin-top: 138px;
  background-color: #fefefe;
  width: 100%;
  //position: absolute;
  bottom: 0;
}
.footer__inner-1{
  border-top: 1.25px solid var(--color-grey-87, #DEDEDE);
  border-bottom: 1.25px solid var(--color-grey-87, #DEDEDE);
  padding: 24px 36px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: font family/Font 1;
  font-weight: font weight/700;
  font-style: Bold;
  font-size: 22.5px;
  leading-trim: NONE;
  line-height: 31.25px;
  letter-spacing: -1%;
  vertical-align: middle;
  &-icon-wrapper{
    display: flex;
    align-items: center;
    gap:30px;
    a{
      display: inline-flex;
      align-items: center;
    }
    img{
      display: block;
    }
  }
}

.footer__inner-2 li{
  border-bottom: 1.25px solid var(--color-grey-87, #DEDEDE);
  padding: 22px 36px;
  font-family: font family/Font 1;
  font-weight: font weight/350;
  font-style: DemiLight;
  font-size: 18.75px;
  leading-trim: NONE;
  line-height: 31.25px;
  letter-spacing: -1%;
  vertical-align: middle;
  color: #222222;
  &:active{
    font-weight: font weight/700;
    font-style: Bold;
  }
}

.footer__inner-3{
  font-family: font family/Font 1;
  font-weight: font weight/350;
  font-style: DemiLight;
  font-size: 16.25px;
  leading-trim: NONE;
  line-height: 31.25px;
  letter-spacing: -1%;
  vertical-align: middle;
  margin: 20px 36px 46px;
}
.footer__inner-4{
  background: #F8F9FA;
  font-family: font family/Font 1;
  font-weight: font weight/350;
  font-style: DemiLight;
  font-size: 18.75px;
  leading-trim: NONE;
  line-height: 31.25px;
  letter-spacing: -1%;
  vertical-align: middle;
  padding: 37px;
}

// Family Site 드롭다운
.family-site-wrapper {
  position: relative;
  padding: 0 !important;
}

.family-site-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 22px 36px;
  cursor: pointer;
  transition: background-color 0.2s;
  //border-bottom: 1px solid var(--color-grey-87, #DEDEDE);
  &:hover {
    background-color: #f5f5f5;
  }

  &:active {
    background-color: #e8e8e8;
    font-weight: font weight/700;
    font-style: Bold;
  }

  span {
    font-family: font family/Font 1;
    font-weight: font weight/350;
    font-style: DemiLight;
    font-size: 18.75px;
    leading-trim: NONE;
    line-height: 31.25px;
    letter-spacing: -1%;
    vertical-align: middle;
    color: #222222;
  }

  .arrow-icon {
    display: inline-flex;
    align-items: center;
    transition: transform 0.3s ease;

    img {
      //width: 16px;
      height: auto;
    }

    &.rotated {
      transform: rotate(180deg);
    }
  }

  // 모바일 - 좌우 20px 통일
  @media (max-width: 768px) {
    padding: 14px 20px;
    min-height: 48px;

    span {
      font-size: 15px;
      line-height: 24px;
    }

    .arrow-icon img {
      width: 14px;
    }
  }
}

.family-site-dropdown {
  list-style: none;
  padding: 0;
  margin: 0;
  background-color: #fafafa;
  border-bottom: 1.25px solid var(--color-grey-87, #DEDEDE);

  .family-site-item {
    padding: 18px 36px 18px 56px;
    font-family: font family/Font 1;
    font-weight: font weight/350;
    font-style: DemiLight;
    font-size: 17px;
    leading-trim: NONE;
    line-height: 28px;
    letter-spacing: -1%;
    color: #666;
    cursor: pointer;
    transition: background-color 0.2s;
    border-bottom: none !important;

    &:hover {
      background-color: #ececec;
      color: #0032A5;
    }

    &:active {
      background-color: #e0e0e0;
    }

    // 모바일 - 좌측 20px + 24px 인덴트
    @media (max-width: 768px) {
      padding: 12px 20px 12px 44px;
      font-size: 14px;
      line-height: 22px;
      min-height: 44px;
    }
  }
}

// 드롭다운 애니메이션
.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.3s ease;
  overflow: hidden;
}

.dropdown-enter,
.dropdown-leave-to {
  max-height: 0;
  opacity: 0;
}

.dropdown-enter-to,
.dropdown-leave {
  max-height: 300px;
  opacity: 1;
}

// 반응형 - 모바일 (좌우 20px 통일)
@media (max-width: 768px) {
  footer {
    margin-top: 60px;
  }

  .footer__inner-1 {
    padding: 16px 20px;
    font-size: 16px;
    line-height: 24px;

    &-icon-wrapper {
      gap: 16px;

      img {
        width: 24px !important;
        height: auto;
      }

      a {
        min-width: 44px;
        min-height: 44px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .footer__inner-2 li {
    padding: 14px 20px;
    font-size: 15px;
    line-height: 24px;
    min-height: 48px;
    //display: flex;
    align-items: center;
  }

  .footer__inner-3 {
    font-size: 12px;
    line-height: 20px;
    margin: 16px 20px 24px;
  }

  .footer__inner-4 {
    font-size: 13px;
    line-height: 22px;
    padding: 20px;
  }
}


</style>